import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { OrgUnit } from './OrgUnit';
import { UserView } from './UserView';
import { ADMIN_NODE_AND_DESCENDANTS, DIRECT_MEMBER_OR_FOLLOWED_NODE_IDS } from './SecurityRules';

export interface OrgUnitMemberRow {
  id: number;
  org_unit_id: number;
  user_id: string;
  source_type: string;
  source_id: number | null;
  is_verified: boolean;
  is_admin: boolean;
  created_at: string;
}

export const OrgUnitMember: Entity<OrgUnitMemberRow> = {
  id: 'OrgUnitMember',
  title: 'Org Unit Member',
  service: 'main',
  rowLabel: (row: OrgUnitMemberRow) => [row.org_unit_id, row.user_id].join(' / '),
  rowLabelDynamic: (row: OrgUnitMemberRow) => `<lookup:UserView:${row.user_id}> / <lookup:OrgUnit:${row.org_unit_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.org_unit_member',
  },
  security: [
    { role: 'user', action: 'read', access: 'conditional', condition: `user_id = '{userId}'` },
    {
      role: 'user',
      action: 'update',
      access: 'conditional',
      condition: `org_unit_id IN ${ADMIN_NODE_AND_DESCENDANTS}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['org_unit_id', 'ASC']],
  defaultFilters: [{ fieldId: 'org_unit_id', operator: 'eq', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    org_unit_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Org Unit',
      mandatory: true,
      listColumn: true,
      refEntity: OrgUnit,
    },
    user_id: {
      seq: 15,
      type: FieldType.Reference,
      label: 'User',
      mandatory: true,
      listColumn: true,
      refEntity: UserView,
    },
    source_type: {
      seq: 20,
      type: FieldType.Text,
      label: 'Source Type',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
    },
    source_id: {
      seq: 25,
      type: FieldType.Integer,
      label: 'Source Id',
      persistence: PersistenceType.BackEndManaged,
    },
    is_verified: {
      seq: 30,
      type: FieldType.Boolean,
      label: 'Is Verified?',
      mandatory: true,
      listColumn: true,
    },
    is_admin: {
      seq: 35,
      type: FieldType.Boolean,
      label: 'Is Admin?',
      mandatory: true,
      listColumn: true,
    },
    created_at: {
      seq: 40,
      type: FieldType.Datetime,
      label: 'Created At',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
  },
};
